import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Interaction, InteractionType, InteractionsMap, TooltipInteraction } from 'types/interactiveWidget.types';

import { hasInteraction } from '../Toolbar/InteractiveMenu/InteractiveMenu.helpers';
import { ExpandInteractionWrapper } from './ExpandInteractionWrapper';
import { INTERACTION_TYPE_PRIORITY, INTERACTIVE_ELEMENT_WRAPPER_CLASSNAME } from './InteractiveElement.config';
import { TooltipInteractionWrapper } from './TooltipInteractionWrapper';

interface InteractiveElementWrapperProps {
  interactions: InteractionsMap | undefined;
  children: ReactNode;
}

export const InteractiveElementWrapper = ({ interactions, children }: InteractiveElementWrapperProps) => {
  const widgetHasInteractions = hasInteraction(interactions);
  if (!interactions || !widgetHasInteractions) return <>{children}</>;

  return (
    <Box
      w='full'
      h='full'
      position='absolute'
      className={INTERACTIVE_ELEMENT_WRAPPER_CLASSNAME}
      top={0}
      left={0}
      pointerEvents='none'
    >
      {Object.keys(interactions)
        .sort(
          (a, b) =>
            INTERACTION_TYPE_PRIORITY.indexOf(b as InteractionType) -
            INTERACTION_TYPE_PRIORITY.indexOf(a as InteractionType),
        )
        .reduce((acc: ReactNode, type) => {
          if (!(interactions[type as InteractionType] as Interaction)) return acc;

          switch (type) {
            case InteractionType.Tooltip:
              return (
                <TooltipInteractionWrapper interaction={interactions[type] as TooltipInteraction}>
                  {acc}
                </TooltipInteractionWrapper>
              );
            case InteractionType.Expandable:
              return <ExpandInteractionWrapper modalContent={children}>{acc}</ExpandInteractionWrapper>;
            default:
              return <>{acc}</>;
          }
        }, children)}
    </Box>
  );
};
